import React, { createContext, useState, useContext } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const getHomeRoute = (rol) => {
  if (rol === 'SuperAdmin')    return '/admin/usuarios';
  if (rol === 'AdminNegocio')  return '/negocio/agenda';
  if (rol === 'Recepcionista') return '/negocio/agenda';
  return '/agenda';  // Profesional independiente
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem('usuario');
    return u ? JSON.parse(u) : null;
  });

  const login = async (usuario, password) => {
    const response = await api.post('/auth/login', { usuario, password });
    const { access_token, refresh_token, usuario: userData } = response.data;

    localStorage.setItem('token',         access_token);
    localStorage.setItem('refresh_token', refresh_token);
    localStorage.setItem('usuario',       JSON.stringify(userData));
    api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    setIsAuthenticated(true);
    setUser(userData);
    return userData;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch { /* ignorar */ }
    ['token', 'refresh_token', 'usuario'].forEach(k => localStorage.removeItem(k));
    delete api.defaults.headers.common['Authorization'];
    setIsAuthenticated(false);
    setUser(null);
  };

  const homeRoute = user ? getHomeRoute(user.rol) : '/login';

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, homeRoute }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default useAuth;
